import { ApiService } from '../services/api/ApiService'

const useApi = () => {
  return new ApiService()
}

export default useApi
